<template>
  <v-flex
    v-if="isDataLoading && isVolunteersLoading"
    md10
    offset-md1
    sm10
    offset-sm1
    xs12
    mt-3
    :mx-3="$vuetify.breakpoint.xsOnly"
  >
    <a
      class="link_iconed"
      @click.prevent="goToCard"
    >
      <v-icon>keyboard_arrow_left</v-icon> {{ $t('sheet.cancel_button') }}</a>
    <v-alert
      :value="true"
      class="f-1"
    >
      {{ $t('preview.entrance_info.1') }}
      <span class="fw-600">{{ $t('preview.entrance_info.2') }}</span>
      {{ $t('preview.entrance_info.3') }}
    </v-alert>
    <v-layout wrap>
      <div
        v-if="hasContent"
        class="overflow-hidden"
      >
        <GeneralInfo />
        <FamilyDescription :read-only="readOnly" />
        <FamilyNeeds :read-only="readOnly" />
        <FamilySpecialGifts />
        <v-flex
          v-if="canSendGreaterNeeds"
          xs12
          class="mb-4"
        >
          <v-divider class="mb-3" />
          <h3 class="display-2">
            {{ $t('preview.more_needs_title') }}
          </h3>
          <v-checkbox
            v-model="greaterNeedsFlag"
            :label="$t('preview.more_needs_label')"
            @change="sendGreaterNeeds()"
          />
          <v-divider class="mt-3" />
        </v-flex>
      </div>
      <v-flex
        xs12
        :mt-5="!hasContent"
      >
        <v-layout
          justify-center
          class="mb-4"
        >
          <v-layout
            v-if="(canDoAuditInArea || canDoAuditOnNational) && isCurrentEdition"
            justify-space-between
            :column="$vuetify.breakpoint.xsOnly"
          >
            <v-btn
              color="sz_violet"
              class="mr-0 text-xs-center"
              @click="openCorrectionModal()"
            >
              {{ $t('buttons.send_to_correction') }}
            </v-btn>
            <v-btn
              color="sz_violet"
              class="mr-0 text-xs-center"
              :loading="auditButtonFlag"
              :disabled="auditButtonFlag"
              @click="auditButtonActions()"
            >
              {{ auditButtonTitle }}
            </v-btn>
          </v-layout>
          <v-btn
            v-else
            color="sz_violet"
            class="text-xs-center"
            :loading="sendToAreaAuditLoading"
            :disabled="sendToAreaAuditLoading"
            @click="volunteerAction()"
          >
            {{ buttonForVolunteerTitle }}
          </v-btn>
          <ScrollBottomButton />
        </v-layout>
      </v-flex>
    </v-layout>
    <AppModal
      :visible="correctionModalVisibility"
      @close="closeCorrectionModal()"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('audit.send_to_correction') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1"
            shrink
            :class="[$vuetify.breakpoint.xs ? 'mt-3' : 'mr-4']"
          >
            <a @click="closeCorrectionModal()">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            shrink
          >
            <v-btn
              color="sz_violet"
              :loading="sendToCorrectionLoading"
              :disabled="sendToCorrectionLoading"
              @click="sendToCorrection()"
            >
              {{ $t('buttons.ok') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="sendToNationalModalVisibility"
      @close="closeSendToNationalModal()"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('audit.send_to_national_correction') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1"
            shrink
            :class="[$vuetify.breakpoint.xs ? 'mt-3' : 'mr-4']"
          >
            <a @click="closeSendToNationalModal()">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            shrink
          >
            <v-btn
              color="sz_violet"
              :loading="auditButtonFlag"
              :disabled="auditButtonFlag"
              @click="sendToNationalAudit()"
            >
              {{ $t('buttons.ok') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </AppModal>
    <AppModal
      :visible="showInfo"
      :persistent="true"
      :close-button="false"
    >
      <template slot="content">
        <p class="f-1 mb-0">
          {{ $t('message.send_description_for_verification') }}
        </p>
      </template>
      <template slot="actions">
        <v-layout
          align-center
          class="my-2"
          justify-center
        >
          <v-btn
            color="sz_violet"
            @click="successActions()"
          >
            {{ $t('buttons.ok') }}
          </v-btn>
        </v-layout>
      </template>
    </AppModal>
    <PublishingModal
      v-if="true"
      :visible="publishingModalVisibility"
      :family-id="$route.params.familyId"
      @close="cancelPublish()"
      @redirect="cancelPublish()"
    />
  </v-flex>
  <PageLoader v-else />
</template>

<script>
import FamilyDescription from '@/components/previewForDonor/FamilyDescription';
import FamilyNeeds from '@/components/previewForDonor/FamilyNeeds';
import FamilySpecialGifts from '@/components/previewForDonor/FamilySpecialGifts';
import GeneralInfo from '@/components/previewForDonor/GeneralInfo';
import PublishingModal from '@/components/previewForDonor/PublishingModal';
import AppModal from '@/components/widgets/AppModal.vue';

import PageLoader from '@/components/widgets/PageLoader';
import ScrollBottomButton from '@/components/widgets/ScrollBottomButton';
import permissions from '@/constants/permissions';
import auditPermissionsAndStatuses from '@/mixins/auditPermissionsAndStatuses';

export default {
    name: 'PreviewForDonor',
    components: {
        PageLoader,
        ScrollBottomButton,
        GeneralInfo,
        FamilyDescription,
        FamilyNeeds,
        FamilySpecialGifts,
        PublishingModal,
        AppModal
    },
    mixins: [auditPermissionsAndStatuses],
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.$store.dispatch('sheet/getSheetPermissions', vm.$route.params.familyId);
            vm.$store
                .dispatch('previewForDonor/getPreviewInfo', vm.$route.params.familyId)
                .finally(() => {
                    vm.isDataLoading = true;
                });
            vm.$store
                .dispatch('defaultApi/getFamilyVolunteers', vm.$route.params.familyId)
                .finally(() => {
                    vm.isVolunteersLoading = true;
                });
        });
    },
    beforeRouteLeave (from, to, next) {
        this.$store.commit('previewForDonor/setPreviewInfo', null);
        this.$store.commit('defaultApi/setFamilyVolunteers', null);
        next();
    },
    data () {
        return {
            permissions,
            isDataLoading: false,
            showInfo: false,
            greaterNeedsFlag: false,
            hasSheetPublishPermission: null,
            isVolunteersLoading: false,
            correctionModalVisibility: false,
            sendToCorrectionLoading: false,
            sendToAreaAuditLoading: false,
            sendToNationalModalVisibility: false,
            publishingModalVisibility: false,
            auditButtonFlag: false
        };
    },
    computed: {
        sheetPermissions () {
            return this.$store.getters['sheet/getSheetPermissions'];
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        readOnly () {
            return !this.sheetPermissions.description || !this.isCurrentEdition;
        },
        family () {
            return this.$store.getters['previewForDonor/getPreviewInfo'];
        },
        canSendGreaterNeeds () {
            return (
                (this.hasSheetPublishPermission || this.hasPermissionsForNationalCorrecting) &&
        this.isFamilyVerifiedOnNational
            );
        },
        buttonForVolunteerTitle () {
            if (
                !this.readOnly &&
        ((this.canSendFamilyToAreaAudit && this.canEditSheets) ||
          (this.canSendFamilyToNationalAudit && this.canEditSheets)) &&
        this.family.canBeSentToCorrection
            ) {
                return this.$t('buttons.add_and_send');
            } else {
                return this.$t('buttons.go_to_family_card');
            }
        },
        canPublishFamily () {
            return (
                this.isFamilyVerifiedOnNational &&
        this.hasSheetPublishPermission &&
        this.sheetPermissions.description
            );
        },
        auditButtonTitle () {
            if (this.family && !this.family.canBeSentToCorrection) {
                return this.$t('buttons.go_to_family_card');
            }
            if (this.canDoAuditInArea) {
                return this.$t('buttons.add_and_send');
            }
            if (this.canDoAuditOnNational && !this.canPublishFamily) {
                return this.$t('buttons.go_to_family_card');
            }
            if (this.canPublishFamily) {
                return this.$t('buttons.post_family_description');
            }
            return '';
        },
        hasContent () {
            return this.$store.getters['previewForDonor/hasContent'];
        }
    },
    watch: {
        family: {
            handler (val) {
                if (val && val.hasGreaterNeeds != null) {
                    this.greaterNeedsFlag = val.hasGreaterNeeds;
                }
            }
        }
    },
    created () {
        this.$store.dispatch('auth/hasPermission', this.permissions.SHEET_PUBLISH).then((res) => {
            this.hasSheetPublishPermission = res;
        });
    },
    methods: {
        successActions () {
            this.showInfo = false;
            this.goToCard();
        },
        goToCard () {
            this.$router.push({ name: 'family-card', params: { id: this.$route.params.familyId } });
        },
        sendGreaterNeeds () {
            const data = {
                id: this.$route.params.familyId,
                greaterNeedsFlag: this.greaterNeedsFlag
            };
            this.$store.dispatch('previewForDonor/sendGreaterNeeds', data);
        },
        openCorrectionModal () {
            this.correctionModalVisibility = true;
        },
        closeCorrectionModal () {
            this.correctionModalVisibility = false;
        },
        openSendToNationalModal () {
            this.sendToNationalModalVisibility = true;
        },
        closeSendToNationalModal () {
            this.sendToNationalModalVisibility = false;
        },
        sendToCorrection () {
            this.sendToCorrectionLoading = true;
            if (this.canDoAuditInArea) {
                this.$store
                    .dispatch('audit/sendToAreaCorrection', this.$route.params.familyId)
                    .then(() => {
                        this.closeCorrectionModal();
                        this.goToCard();
                    })
                    .finally(() => {
                        this.sendToCorrectionLoading = false;
                    });
            } else if (this.canDoAuditOnNational) {
                this.$store
                    .dispatch('audit/sendToNationalCorrection', this.$route.params.familyId)
                    .then(() => {
                        this.closeCorrectionModal();
                        this.goToCard();
                    })
                    .finally(() => {
                        this.sendToCorrectionLoading = false;
                    });
            }
        },
        sendToNationalCorrectionVolunteer () {
            this.sendToAreaAuditLoading = true;
            this.$store
                .dispatch('audit/sendToNationalCorrectionVolunteer', this.$route.params.familyId)
                .then(() => {
                    this.showInfo = true;
                })
                .finally(() => {
                    this.sendToAreaAuditLoading = false;
                });
        },
        sendToAreaAudit () {
            this.sendToAreaAuditLoading = true;
            this.$store
                .dispatch('audit/sendToAreaAudit', this.$route.params.familyId)
                .then(() => {
                    this.showInfo = true;
                })
                .finally(() => {
                    this.sendToAreaAuditLoading = false;
                });
        },
        volunteerAction () {
            if (
                !this.readOnly &&
        this.canSendFamilyToAreaAudit &&
        this.canEditSheets &&
        this.family.canBeSentToCorrection
            ) {
                this.sendToAreaAudit();
            } else if (
                !this.readOnly &&
        this.canSendFamilyToNationalAudit &&
        this.canEditSheets &&
        this.family.canBeSentToCorrection
            ) {
                this.sendToNationalCorrectionVolunteer();
            } else {
                this.goToCard();
            }
        },
        sendToNationalAudit () {
            this.auditButtonFlag = true;
            this.$store
                .dispatch('audit/sendToNationalAudit', this.$route.params.familyId)
                .then(() => {
                    this.sendToNationalModalVisibility = false;
                    this.showInfo = true;
                })
                .finally(() => {
                    this.auditButtonFlag = false;
                });
        },
        openPublishModal () {
            this.auditButtonFlag = true;
            this.publishingModalVisibility = true;
        },
        cancelPublish () {
            this.publishingModalVisibility = false;
            this.auditButtonFlag = false;
        },
        auditButtonActions () {
            if (!this.family.canBeSentToCorrection) {
                this.goToCard();
            } else if (this.canDoAuditInArea) {
                this.openSendToNationalModal();
            } else if (this.canDoAuditOnNational && !this.canPublishFamily) {
                this.goToCard();
            } else if (this.canPublishFamily) {
                this.openPublishModal();
            }
        }
    }
};
</script>

<style scoped></style>
